<template>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
      <a class="navbar-brand brand-logo" :href="logoUrl">
        <img
          :src="brandLogoSrc"
          alt="Mozali"
          class="sidebar-brand-logo"
        />
      </a>
      <a class="navbar-brand brand-logo-mini" :href="logoUrl">
        <span v-if="brandLogoIconSrc" class="sidebar-brand-logo-mini-shell">
          <img
            :src="brandLogoIconSrc"
            alt="Mozali"
            class="sidebar-brand-logo-mini"
          />
        </span>
      </a>
    </div>

    <ul class="nav nav-scrolling">

      <li class="nav-item" v-for="(item, index) in data" :key="index" v-if="item.permission">
        <a class="nav-link"
           :href="item.id ? '#'+item.id : item.url"
           :data-toggle="item.id ? 'collapse' : false"
           :aria-expanded="item.id ? 'false' : false"
           :aria-controls="item.id ? item.id : false"
           :data-active-patterns="(item.activePatterns || []).join('|')">
                    <span class="icon-wrapper">
                        <app-icon :name="item.icon" class="menu-icon"/>
                    </span>
          <span class="menu-title">{{ item.name }}</span>
          <i v-if="item.subMenu" class="menu-arrow"/>
        </a>

        <div class="collapse" v-if="item.subMenu" :id="item.id">
          <ul class="nav flex-column sub-menu">
            <li class="nav-item"
                v-for="(submenuItem, index) in item.subMenu"
                :key="index"
                v-if="submenuItem.permission === true || submenuItem.permission === ''">
              <a class="nav-link" :href="submenuItem.url">
                {{ submenuItem.name }}
              </a>
            </li>
          </ul>
        </div>
      </li>

    </ul>

    <div class="sidebar-logout-area">
      <a class="nav-link sidebar-logout-link" :href="logoutUrl">
        <span class="icon-wrapper">
          <app-icon name="log-out" class="menu-icon"/>
        </span>
        <span class="menu-title">{{ $t('logout') }}</span>
      </a>
    </div>
  </nav>
</template>

<script>
import { AuthMixin } from "../../../app/Components/Views/Auth/Mixins/AuthMixin";
import AppFunction from "../../helpers/app/AppFunction";
import * as actions from "../../../app/Config/ApiUrl";
import { urlGenerator } from "../../../app/Helpers/AxiosHelper";

export default {
  name: "Sidebar",
  mixins: [AuthMixin],
  data() {
    return {
      logoutUrl: urlGenerator(actions.LOGOUT)
    };
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    companyName: {
      type: String,
      default: ''
    },
    logoSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/logo.png'),
    },
    logoIconSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/logo.png'),
    },
    logoUrl: {
      type: String,
      default: '/'
    }
  },
  mounted() {
    this.$nextTick(function () {
      let body = $('body'),
          current = location.pathname,
          sidebar = $('.sidebar'),
          sidebarType = localStorage.getItem('sidebar');

      $(function () {
        // Add active class to nav-link based on url dynamically
        function addActiveClass(element) {
          const href = element.attr('href') || '';
          const rawPatterns = element.attr('data-active-patterns') || '';
          const activePatterns = rawPatterns.split('|').filter(Boolean);
          const matchesCustomPattern = activePatterns.some((pattern) => current.indexOf(pattern) === 0);

          if (matchesCustomPattern || href.indexOf(current) !== -1) {
            element.parents('.nav-item').last().addClass('active');
            if (sidebarType === 'floating') {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').removeClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            } else {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').addClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            }
          }
        }

        $('.nav li a', sidebar).each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        $('.horizontal-menu .nav li a').each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        // Close other submenu in sidebar on opening any
        sidebar.on('show.bs.collapse', '.collapse', function () {
          sidebar.find('.collapse.show').collapse('hide');
        });

        // Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
          //Applying perfect scrollbar
          if (!body.hasClass("rtl")) {
            if (body.hasClass("sidebar-fixed")) {
              let fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
            }
          }
        }
      });

      const HOVER_CLOSE_DELAY = 180;
      const clearHoverCloseTimer = ($menuItem) => {
        const timerId = $menuItem.data('hoverCloseTimer');
        if (timerId) {
          clearTimeout(timerId);
          $menuItem.removeData('hoverCloseTimer');
        }
      };
      const openHoverPanel = ($menuItem) => {
        clearHoverCloseTimer($menuItem);
        $menuItem.addClass('hover-open');
      };
      const scheduleHoverClose = ($menuItem) => {
        clearHoverCloseTimer($menuItem);
        const timerId = setTimeout(() => {
          $menuItem.removeClass('hover-open');
          $menuItem.removeData('hoverCloseTimer');
        }, HOVER_CLOSE_DELAY);
        $menuItem.data('hoverCloseTimer', timerId);
      };
      const isInsideSameMenuItem = ($menuItem, target) => {
        if (!target) {
          return false;
        }

        return target === $menuItem[0] || $menuItem.has(target).length > 0;
      };

      // Sidebar collapse menu on hover
      $(document).on('mouseenter', '.sidebar .nav-item', function () {
        let body = $('body');
        let sidebarIconOnly = body.hasClass("sidebar-icon-only");
        let sidebarFixed = body.hasClass("sidebar-fixed");

        if (!sidebarIconOnly) {
          return;
        }

        if (sidebarFixed) {
          body.removeClass('sidebar-icon-only');
          return;
        }

        openHoverPanel($(this));
      });

      $(document).on('mouseleave', '.sidebar .nav-item', function (ev) {
        let body = $('body');

        if (!body.hasClass("sidebar-icon-only") || body.hasClass("sidebar-fixed")) {
          return;
        }

        const $menuItem = $(this);

        if (isInsideSameMenuItem($menuItem, ev.relatedTarget)) {
          return;
        }

        scheduleHoverClose($menuItem);
      });

      $(document).on('mouseenter', '.sidebar .nav-item .collapse, .sidebar .nav-item .menu-title', function () {
        let body = $('body');

        if (!body.hasClass("sidebar-icon-only") || body.hasClass("sidebar-fixed")) {
          return;
        }

        openHoverPanel($(this).closest('.nav-item'));
      });

      $(document).on('mouseleave', '.sidebar .nav-item .collapse, .sidebar .nav-item .menu-title', function (ev) {
        let body = $('body');

        if (!body.hasClass("sidebar-icon-only") || body.hasClass("sidebar-fixed")) {
          return;
        }

        const $menuItem = $(this).closest('.nav-item');

        if (isInsideSameMenuItem($menuItem, ev.relatedTarget)) {
          return;
        }

        scheduleHoverClose($menuItem);
      });

      $(document).on('click', '.sidebar .nav-item > .nav-link[data-toggle="collapse"]', function (ev) {
        let body = $('body');

        if (!body.hasClass("sidebar-icon-only") || body.hasClass("sidebar-fixed")) {
          return;
        }

        ev.preventDefault();
        openHoverPanel($(this).closest('.nav-item'));
      });

      // Close collapse menu when mouse leave from sidebar hover only
      $(document).on('mouseenter mouseleave', '.sidebar-hover-only .sidebar', function (ev) {
        if (ev.type === 'mouseleave') {
          $('.sidebar').find('.collapse.show').collapse('hide');
        } else {

        }
      });
    });
  },
  computed: {
    brandLogoSrc() {
      return AppFunction.getAppUrl('logo_format_white.png');
    },
    brandLogoIconSrc() {
      return this.logoIconSrc || AppFunction.getAppUrl('images/favicon.png');
    }
  }
}
</script>

<style scoped>
.sidebar-brand-logo {
  width: 100%;
  max-width: 188px;
  height: auto;
  object-fit: contain;
  display: block;
}

.sidebar-brand-logo-mini-shell {
  width: 56px;
  height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sidebar-brand-logo-mini {
  width: 48px;
  height: 48px;
  object-fit: contain;
  display: block;
}

.sidebar-company-name {
  font-size: 22px;
  color: var(--mozali-sidebar-brand-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.1;
  text-shadow: none;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav.nav-scrolling {
  padding-bottom: 6rem;
}

.sidebar-logout-area {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.8rem 0.6rem 1rem;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    var(--sidebar-bg) 28%
  );
}

.sidebar-logout-link {
  display: flex;
  align-items: center;
  border: 0;
  background-color: transparent;
  border-radius: var(--mozali-radius-md);
  min-height: 50px;
  padding: 0.52rem 0.72rem;
  color: var(--sidebar-text-muted);
  font-weight: 600;
  transition: background-color var(--mozali-motion-micro) var(--mozali-motion-ease),
    color var(--mozali-motion-micro) var(--mozali-motion-ease);
}

.sidebar-logout-link .icon-wrapper {
  width: 38px;
  height: 38px;
  min-width: 38px;
  max-width: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--sidebar-icon-bg);
}

.sidebar-logout-link .menu-title {
  margin-left: 0.75rem;
  letter-spacing: 0.01em;
}

.sidebar-logout-link:hover {
  background-color: var(--sidebar-hover-bg);
  color: var(--sidebar-text);
}

.sidebar-logout-link:hover .icon-wrapper {
  background-color: var(--sidebar-icon-active-bg);
}
</style>
